import { useAsync } from '@nxsys/hooks/useAsync';
import {
  approvePaymentApi,
  downloadP30Api,
  downloadP32Api,
  exportCISStatementOfEarningsApi,
  exportEarningStatementApi,
  exportNowPensionApi,
  exportPapdisPensionApi,
  exportPensionApi,
  exportPensionAssessedApi,
  exportPensionIrelandApi,
  generatePaymentFileApi,
  getDormantWorkerListApi,
  getEarningReportListApi,
  getEarningStatementListApi,
  getNestExportPeriodApi,
  getPensionContributionReportListApi,
  getScheduleForApprovePaymentApi,
  getSubmissionsForApprovePaymentApi,
  markAsSubmittedPensionApi,
  resubmitPensionApi,
  saveP30P32SettingApi,
  sendMultipleMailCISStatementOfEarningsApi,
  submitPensionContributionReportApi,
} from '@nxsys/services/api/report';
import {
  ExportNowPensionParams,
  ExportNowPensionResponse,
  ExportPapdisPensionParams,
  ExportPapdisPensionResponse,
  ExportPensionIrelandParams,
  ExportPensionIrelandResponse,
  ExportPensionParams,
  ExportPensionResponse,
  GeneratePaymentFileParams,
  GeneratePaymentFileResponse,
  GetAutoEnrollmentStatusListParams,
  GetCISStateOfEarningsListParams,
  GetCISStateOfEarningsListResponse,
  GetDormantWorkerListParams,
  GetDormantWorkerListResponse,
  GetPensionContributionReportListParams,
  GetPensionContributionReportListResponse,
  GetNestExportPeriodParams,
  GetNestExportPeriodResponse,
  GetScheduleForApprovePaymentParams,
  GetScheduleForApprovePaymentResponse,
  GetSubmissionsForApprovePaymentParams,
  GetSubmissionsForApprovePaymentResponse,
  MarkAsSubmittedPensionParams,
  MarkAsSubmittedPensionResponse,
  ResubmitPensionParams,
  ResubmitPensionResponse,
  SaveP30P32SettingParams,
  SaveP30P32SettingResponse,
  SubmitPensionContributionReportParams,
  SubmitPensionContributionReportResponse,
  DownloadP30Params,
  DownloadP32Params,
  DownloadP30P32Response,
} from '@nxsys/store/slices/report/types';
import {
  ExportCISStatementOfEarningsParams,
  ExportCISStatementOfEarningsResponse,
  SendMultipleMailCISStatementOfEarningsParams,
} from '@nxsys/types/api/report';
import {
  GetEarningStatementListParams,
  GetEarningStatementListResponse,
  ExportEarningStatementParams,
  ExportEarningStatementResponse,
} from '@nxsys/types/models/earningReport/v2';
import { showMessage } from '@nxsys/utils/message';
import { useEffect } from 'react';
import { getErrorMessage } from '@nxsys/utils/getErrorMessage';

export const useSendMultipleMailCISStatementOfEarnings = () => {
  const { value, loading, error, run } = useAsync<
    { success: boolean },
    SendMultipleMailCISStatementOfEarningsParams
  >(sendMultipleMailCISStatementOfEarningsApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useExportCISStatementOfEarnings = () => {
  const { value, loading, error, run } = useAsync<
    ExportCISStatementOfEarningsResponse,
    ExportCISStatementOfEarningsParams
  >(exportCISStatementOfEarningsApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetEarningReportList = () => {
  const { value, loading, error, run } = useAsync<
    GetCISStateOfEarningsListResponse,
    GetCISStateOfEarningsListParams
  >(getEarningReportListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetDormantWorkerList = () => {
  const { value, loading, error, run } = useAsync<
    GetDormantWorkerListResponse,
    GetDormantWorkerListParams
  >(getDormantWorkerListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useExportPensionAssessed = () => {
  const { value, loading, error, run } = useAsync<
    any,
    GetAutoEnrollmentStatusListParams
  >(exportPensionAssessedApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useExportNowPension = () => {
  const { value, loading, error, run } = useAsync<
    ExportNowPensionResponse,
    ExportNowPensionParams
  >(exportNowPensionApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useExportPapdisPension = () => {
  const { value, loading, error, run } = useAsync<
    ExportPapdisPensionResponse,
    ExportPapdisPensionParams
  >(exportPapdisPensionApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useExportPension = () => {
  const { value, loading, error, run } = useAsync<
    ExportPensionResponse,
    ExportPensionParams
  >(exportPensionApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetPensionContributionReportList = () => {
  const { value, loading, error, run } = useAsync<
    GetPensionContributionReportListResponse,
    GetPensionContributionReportListParams
  >(getPensionContributionReportListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useResubmitPension = () => {
  const { value, loading, error, run } = useAsync<
    ResubmitPensionResponse,
    ResubmitPensionParams
  >(resubmitPensionApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useMarkAsSubmittedPension = () => {
  const { value, loading, error, run } = useAsync<
    MarkAsSubmittedPensionResponse,
    MarkAsSubmittedPensionParams
  >(markAsSubmittedPensionApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useSubmitPensionContributionReport = () => {
  const { value, loading, error, run } = useAsync<
    SubmitPensionContributionReportResponse,
    SubmitPensionContributionReportParams
  >(submitPensionContributionReportApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetNestExportPeriod = () => {
  const { value, loading, error, run } = useAsync<
    GetNestExportPeriodResponse,
    GetNestExportPeriodParams
  >(getNestExportPeriodApi);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetScheduleForApprovePayment = () => {
  const { value, loading, error, run } = useAsync<
    GetScheduleForApprovePaymentResponse,
    GetScheduleForApprovePaymentParams
  >(getScheduleForApprovePaymentApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetSubmissionsForApprovePayment = () => {
  const { value, loading, error, run } = useAsync<
    GetSubmissionsForApprovePaymentResponse,
    GetSubmissionsForApprovePaymentParams
  >(getSubmissionsForApprovePaymentApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useApprovePayment = () => {
  const { value, loading, error, run } = useAsync<any, string>(
    approvePaymentApi,
  );

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useDownloadP30 = () => {
  const { value, loading, error, run } = useAsync<
    DownloadP30P32Response,
    DownloadP30Params
  >(downloadP30Api);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useDownloadP32 = () => {
  const { value, loading, error, run } = useAsync<
    DownloadP30P32Response,
    DownloadP32Params
  >(downloadP32Api);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useSaveP30P32Setting = () => {
  const { value, loading, error, run } = useAsync<
    SaveP30P32SettingResponse,
    SaveP30P32SettingParams
  >(saveP30P32SettingApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGeneratePaymentFile = () => {
  const { value, loading, error, run } = useAsync<
    GeneratePaymentFileResponse,
    GeneratePaymentFileParams & { id: number }
  >(({ id, ...params }) => generatePaymentFileApi(id, params));

  const _run = async (id: number, params: GeneratePaymentFileParams) => {
    return run({ id, ...params });
  };

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run: _run,
  };
};

export const useExportPensionIreland = () => {
  const { value, loading, error, run } = useAsync<
    ExportPensionIrelandResponse,
    ExportPensionIrelandParams
  >(exportPensionIrelandApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useGetEarningStatementList = () => {
  const { value, loading, error, run } = useAsync<
    GetEarningStatementListResponse,
    GetEarningStatementListParams
  >(getEarningStatementListApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};

export const useExportEarningStatement = () => {
  const { value, loading, error, run } = useAsync<
    ExportEarningStatementResponse,
    ExportEarningStatementParams
  >(exportEarningStatementApi);

  useEffect(() => {
    if (error) {
      showMessage({
        type: 'error',
        content: getErrorMessage(error),
      });
    }
  }, [error]);

  return {
    value,
    loading,
    error,
    run,
  };
};
